import {POST, GET, DELETE} from "@/services/gateway";

const listExport = ({pagination, sourceType, dataTypes, dataProvider = 'MICROSOFT'}) => {
  return POST('recovery/export/list', {pagination, sourceType, dataTypes, dataProvider})
}

const downloadExport = (id) => {
  return GET(`recovery/export/${id}/download`)
}

const deleteExport = (id) => {
  return DELETE(`recovery/export`, id)
}

const cancelExport = (id, module) => {
  return GET(`${module}/export/${id}/cancel`)
}

const cancelExportWithRecovery = (id, module) => {
  return GET(`recovery/${module}/export/${id}/cancel`)
}

export {
  listExport,
  deleteExport,
  downloadExport,
  cancelExport,
  cancelExportWithRecovery
}
